"use strict";

const Debug = require('debug');

const taskModule = require('./task');

const {
  downloadZipApi
} = require('../utils/api-utils');

const {
  bytes32Schema,
  throwIfMissing
} = require('../utils/validator');

const debug = Debug('iexec:execution:result');

const downloadFromIpfs = async function (ipfsAddress) {
  let {
    ipfsGatewayURL = 'https://gateway.ipfs.io'
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  try {
    const res = await downloadZipApi.get({
      api: ipfsGatewayURL,
      endpoint: ipfsAddress
    });
    return res;
  } catch (error) {
    throw Error("Failed to download from ".concat(ipfsGatewayURL, ": ").concat(error.message));
  }
};

const fetchTaskResults = async function () {
  let contracts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : throwIfMissing();
  let taskid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : throwIfMissing();
  let {
    ipfsGatewayURL
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  try {
    const vTaskId = await bytes32Schema().validate(taskid);
    const task = await taskModule.show(contracts, vTaskId);
    if (task.status !== 3) throw Error('Task is not completed');
    const {
      storage,
      location
    } = task.results;

    if (storage === 'none') {
      throw Error('No result uploaded for this task');
    }

    if (storage !== 'ipfs') {
      throw Error("Task result stored on ".concat(storage, ", download not supported"));
    }

    if (!location) {
      throw Error('Missing location key in task results, download not supported');
    }

    const res = await downloadFromIpfs(location, {
      ipfsGatewayURL
    });
    return res;
  } catch (error) {
    debug('fetchResults()', error);
    throw error;
  }
};

module.exports = {
  fetchTaskResults
};